import { Divider, Skeleton, Stack } from "@mui/material";
import { Constants } from "../../utils/constants";
import BorderWidget from "./border_widget";


export default function AccountPlanSkeleton() {
    return (
        <BorderWidget
            sx={{
                boxShadow: "0px 1px 3px 0px #0000001a",
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 6)`,
                },
                borderRadius: `calc(${Constants.Styles.radius.base} + 4px)`,
                flex: 1,
            }}
        >
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
            >
                <Skeleton
                    variant="rounded"
                    height={20}
                    width={100}
                />
                <Skeleton
                    variant="rounded"
                    width={60}
                    height={30}
                />
            </Stack>
            <Skeleton
                variant="rounded"
                height={20}
                width={240}
            />
            <Skeleton
                variant="rounded"
                height={60}
                width={"100%"}
                sx={{
                    marginBlock: "1.125rem",
                }}
            />
            <Divider />
            <Stack
                sx={{
                    marginBlock: "0.75rem",
                }}
                spacing={"0.75rem"}
            >
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                >
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                </Stack>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                >
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                </Stack>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                >
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                    <Skeleton
                        variant="text"
                        fontSize={Constants.Styles.fontSize.base}
                        width={70}
                    />
                </Stack>
            </Stack>
            <Skeleton
                variant="rounded"
                height={40}
                width={"100%"}
            />
        </BorderWidget>
    );
}